(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('LogsService', LogsService);

  LogsService.$inject = ['$resource', 'API_URI'];

  function LogsService($resource, API_URI) {
    return $resource(API_URI + 'management/jhipster/logs', {}, {
      'findAll': {method: 'GET', isArray: true},
      'changeLevel': {method: 'PUT'}
    });
  }
})();
